<template>
	<div class="monitor-dashboard">
		<!-- 核心看板 -->
		<div class="core-board breath-panel">
			<div class="flex-between title-box">
				<div class="board-title">核心看板</div>
				<div class="board-right-title">今日告警/对比趋势/24H</div>
			</div>
			<div class="alert-grid">
				<div class="alert-card all">
					<div class="alert-label">今日告警总数</div>
					<div class="alert-value">{{ event_overviewData.totalToday }}起</div>
					<div class="alert-label">全量等级汇总</div>
				</div>
				<div class="alert-card urgent">
					<div class="alert-label">紧急告警</div>
					<div class="alert-value">{{ event_overviewData.urgentCount }}起</div>
					<div class="alert-label">等待处置</div>
				</div>
				<div class="alert-card focus">
					<div class="alert-label">关注告警</div>
					<div class="alert-value">{{ event_overviewData.focusCount }}起</div>
					<div class="alert-label">持续复现</div>
				</div>
				<div class="alert-card normal">
					<div class="alert-label">一般告警</div>
					<div class="alert-value">{{ event_overviewData.generalCount }}起</div>
					<div class="alert-label">跟踪闭环</div>
				</div>
			</div>
		</div>

		<!-- 事件对比 -->
		<div class="event-compare breath-panel">
			<div class="compare-title">事件对比</div>
			<div class="compare-tabs">
				<span :class="{ tab: true, active: item.key == dateKey }" @click="dateClick(item.key)"
					v-for="(item, index) in dateData" :key="index">{{ item.label }}</span>
			</div>
			<div class="compare-content">
				<div class="compare-item">
					<div class="circle-chart">
						<div id="ratio-chart-1"></div>
						<div class="circle-text">
							<div class="percent">{{ compare.yearOnYear.changeRate }}%</div>
							<div class="desc" v-if="compare.yearOnYear.previous > compare.yearOnYear.current">同比下降</div>
							<div class="desc" v-else>同比增长</div>
						</div>
					</div>
					<div class="item-title">事件同比</div>
					<div class="item-desc">今日{{ compare.yearOnYear.current }}起 / 去年同期{{ compare.yearOnYear.previous }}起
					</div>
					<div class="item-status" v-if="compare.yearOnYear.previous > compare.yearOnYear.current">
						少{{ compare.yearOnYear.previous - compare.yearOnYear.current }}起，趋势改善</div>
					<div class="item-status" v-else>
						多{{ compare.yearOnYear.current - compare.yearOnYear.previous }}起，还需跟进</div>
				</div>
				<div class="compare-item">
					<div class="circle-chart">
						<div id="ratio-chart-2"></div>
						<div class="circle-text">
							<div class="percent">{{ compare.chain.changeRate }}%</div>
							<div class="desc" v-if="compare.chain.previous > compare.chain.current">同比下降</div>
							<div class="desc" v-else>同比增长</div>
						</div>
					</div>
					<div class="item-title">事件环比</div>
					<div class="item-desc">今日{{ compare.chain.current }}起 / 去年同期{{ compare.chain.previous }}起
					</div>
					<div class="item-status" v-if="compare.chain.previous > compare.chain.current">
						少{{ compare.chain.previous - compare.chain.current }}起，趋势改善</div>
					<div class="item-status" v-else>
						多{{ compare.chain.current - compare.chain.previous }}起，还需跟进</div>
				</div>
			</div>
		</div>

		<!-- 24H告警曲线 -->
		<div class="alert-line breath-panel">
			<div class="line-title">24H告警曲线</div>
			<div class="line-subtitle">告警数量统计，每3小时采样</div>
			<div class="line-right-info">
				峰值12起 / 当前11起
			</div>
			<div id="line-chart" class="chart-container"></div>
		</div>

		<!-- 最近事件操作记录 -->
		<div class="event-record breath-panel">
			<div class="record-title">最近事件操作记录</div>
			<div class="record-right-title">确认/联动/复核</div>
			<div class="record-list">
				<div :class="{ 'record-item': true, normal: true, urgent: item.warnLevel == 0, focus: item.warnLevel == 1 }"
					v-for="(item, index) in page_handle_record_listData" :key="index">
					<!-- <div class="item-time">{{ item.recordTime }}</div> -->
					<div class="item-content">
						<div class="item-name">{{ item.warnName }}</div>
						<div class="item-detail">{{ item.warnContent }}</div>
					</div>
					<div class="item-status-btn" :class="{ urgent: item.warnLevel == 0, focus: item.warnLevel == 1 }">
						{{ item.warnStatusName }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import wsService from '@/utils/websocketService'
	import { getScreenScale } from '@/utils/rem'
	
	export default {
		name: 'EventAlertLeft',
		data() {
			return {
				curve: {
					times: [],
					values: [],
					peakCount: 0
				},
				compare: {
					yearOnYear: {
						changeRate: 0,
						current: 0,
						previous: 0
					},
					chain: {
						changeRate: 0,
						current: 0,
						previous: 0
					}
				},
				dateData: [{
					key: 'day',
					label: '日'
				},
				{
					key: 'week',
					label: '周'
				},
				{
					key: 'month',
					label: '月'
				},
				],
				dateKey: 'day',
				page_handle_record_listData: [],
				event_overviewData: {}
			}
		},
		mounted() {
			this.event_overview();
			this.page_handle_record_list();
			// 初始化告警 WebSocket
			wsService.initWarnWs(this.handleWarnMessage);
		},
		beforeDestroy() {
			// 组件销毁时取消订阅
			wsService.unsubscribeWarn(this.handleWarnMessage);
		},
	methods: {
		// 处理告警 WebSocket 消息：刷新告警相关数据
		handleWarnMessage(message) {
			console.log('[eventAlertLeft] 收到告警推送:', message)
			// 收到新告警，刷新数据
			this.event_overview()
			this.page_handle_record_list()
		},
		dateClick(key) {
			this.dateKey = key;
			this.event_overview();
		},
		event_overview() {
			this.$http.get(this.$api.BASE_URL_Category.event_overview, {
				dateType: this.dateKey
			}).then(res => {
				this.curve = res.data.curve;
				this.compare = res.data.compare;
				this.event_overviewData = res.data;
				this.initCharts();
			})
		},
		page_handle_record_list() {
			this.$http.get(this.$api.BASE_URL_Category.page_handle_record_list, {
				pageNumber: 1,
				pageSize: 100
			}).then(res => {
				this.page_handle_record_listData = res.data.data;
			})
		},
		initCharts() {
			this.$nextTick(() => {
				// 检查环形图数据是否存在
				if (this.compare && this.compare.yearOnYear && this.compare.chain) {
					// 同比环形图
					const chart1El = document.getElementById('ratio-chart-1')
					if (chart1El) {
						const ratioChart1 = this.$echarts.init(chart1El)
						const yearOnYearRate = Math.abs(this.compare.yearOnYear.changeRate) || 0
						ratioChart1.setOption({
							series: [{
								type: 'pie',
								radius: ['70%', '85%'],
								avoidLabelOverlap: false,
								silent: false,
								label: {
									show: false
								},
								labelLine: {
									show: false
								},
								data: [{
									value: yearOnYearRate,
									itemStyle: {
										color: '#36d1ff'
									}
								},
								{
									value: 100 - yearOnYearRate,
									itemStyle: {
										color: 'rgba(255,255,255,0.1)'
									}
								}
								]
							}]
						})
					}

					// 环比环形图
					const chart2El = document.getElementById('ratio-chart-2')
					if (chart2El) {
						const ratioChart2 = this.$echarts.init(chart2El)
						const chainRate = Math.abs(this.compare.chain.changeRate) || 0
						ratioChart2.setOption({
							series: [{
								type: 'pie',
								radius: ['70%', '85%'],
								avoidLabelOverlap: false,
								silent: true,
								label: {
									show: false
								},
								labelLine: {
									show: false
								},
								data: [{
									value: chainRate < 100 ? chainRate : 100,
									itemStyle: {
										color: '#ffb72b'
									}
								},
								{
									value: chainRate < 100 ? (100 - chainRate) : 0,
									itemStyle: {
										color: 'rgba(255,255,255,0.1)'
									}
								}
								]
							}]
						})
					}
					console.log('[eventAlertLeft] 环形图初始化完成')
				} else {
					console.warn('[eventAlertLeft] 环形图数据不完整')
				}

				// 24H告警曲线图
				if (this.curve && this.curve.times && this.curve.values) {
					const lineChartEl = document.getElementById('line-chart')
					if (lineChartEl) {
						const lineChart = this.$echarts.init(lineChartEl)
						const scale = getScreenScale();
						lineChart.setOption({
							grid: {
								// 四向边距随屏幕等比缩放（与字号同乘 scale），
								// y 轴 label 已显示，left 用 55 给刻度留空间；bottom 给 rotate 的 x 轴标签留空间
								top: Math.round(8 * scale),
								left: Math.round(55 * scale),
								right: Math.round(10 * scale),
								bottom: Math.round(65 * scale),
								containLabel: false
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: this.curve.times,
								axisLine: {
									show: false
								},
								axisTick: {
									show: false
								},
								axisLabel: {
									color: 'rgba(255,255,255,0.7)',
									fontSize: Math.round(12 * scale),
									interval: 0,
									rotate: 30,
									margin: 10
								}
							},
							yAxis: {
								type: 'value',
								min: 0,
								max: Math.max(...this.curve.values) + 2,
								splitNumber: 3,
								axisLine: {
									show: false
								},
								axisTick: {
									show: false
								},
								axisLabel: {
									color: 'rgba(255,255,255,0.7)',
									fontSize: Math.round(14 * scale),
									margin: 8
								},
								splitLine: {
									lineStyle: {
										color: 'rgba(255,255,255,0.1)'
									}
								}
							},
							tooltip: {
								trigger: 'axis',
								formatter: '{c}起',
								textStyle: {
									fontSize: Math.round(14 * scale)
								}
							},
							series: [{
								name: '告警数',
								type: 'line',
								smooth: true,
								symbol: 'circle',
								symbolSize: 8,
								data: this.curve.values,
								lineStyle: {
									color: '#36d1ff',
									width: 2
								},
								itemStyle: {
									color: '#36d1ff'
								},
								areaStyle: {
									color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
										[{
											offset: 0,
											color: 'rgba(54, 209, 255, 0.4)'
										},
										{
											offset: 1,
											color: 'rgba(54, 209, 255, 0)'
										}
										])
								}
							}]
						})
						console.log('[eventAlertLeft] 曲线图初始化完成')
					} else {
						console.error('[eventAlertLeft] line-chart 元素未找到')
					}
				} else {
					console.warn('[eventAlertLeft] 曲线图数据不完整:', this.curve)
				}
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.monitor-dashboard {
	width: 420px;
	color: #B3C8DC;
	font-family: 'Microsoft YaHei', sans-serif;
	position: absolute;
	left: 10px;
	top: 90px;
	z-index: 2;

	.core-board {
		height: 186px;
		background: rgba(#091724, 0.8);
				// border: 1px solid #4578A8;
		border-radius: 12px;
		padding: 10px 12px;
		margin-bottom: 10px;
		position: relative;

		.title-box {
			margin-bottom: 10px;

			.board-title {
				font-size: 16px;
			}

			.board-right-title {
				font-size: 12px;
				color: #B3C8DC;
			}
		}


		.alert-grid {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 9px;

			.alert-card {
				padding: 6px 9px;
				width: 195px;
				height: 64px;
				text-align: center;
				background: linear-gradient(0deg, #081724 0%, #16283A 100%);
				border-radius: 7px;
						// border: 1px solid #4578A8;

				&.urgent {
					background: linear-gradient(0deg, #081724 0%, rgba(#FF4A4A, 0.3) 100%);
					border-color: rgba(#FF4A4A, 0.3);
				}

				&.focus {
					background: linear-gradient(0deg, #152738 0%, rgba(#F9C626, 0.3) 100%);
					border-color: rgba(#F9C626, 0.3);
				}

				.alert-value {
					font-weight: 800;
					font-size: 16px;
					color: #B3C8DCFFF;
					margin: 6px 0;

					&.urgent {
						color: #FF4A4A;
					}

					&.focus {
						color: #F9C626;
					}
				}

				.alert-label {
					font-size: 9px;
					color: #B3C8DC;
				}
			}
		}
	}

	.event-compare {
		height: 273px;
		background: rgba(#091724, 0.8);
				// border: 1px solid #4578A8;
		border-radius: 12px;
		padding: 10px 12px;
		margin-bottom: 10px;
		position: relative;

		.compare-title {
			font-size: 16px;
			margin-bottom: 16px;
		}

		.compare-tabs {
			position: absolute;
			top: 16px;
			right: 16px;
			display: flex;
			gap: 8px;

			.tab {
				font-size: 12px;
				color: rgba(255, 255, 255, 0.6);
				padding: 4px 8px;
				border-radius: 4px;
				cursor: pointer;

				&.active {
					background: #36d1ff;
					color: #B3C8DC;
				}
			}
		}

		.compare-content {
			display: flex;
			justify-content: space-around;

			.compare-item {
				text-align: center;
				width: 50%;

				.circle-chart {
					position: relative;
					width: 120px;
					height: 120px;
					margin: 0 auto 12px;

					#ratio-chart-1,
					#ratio-chart-2 {
						width: 100%;
						height: 100%;
					}

					.circle-text {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						text-align: center;

						.percent {
							font-size: 20px;
							font-weight: bold;
						}

						.desc {
							font-size: 12px;
							color: rgba(255, 255, 255, 0.6);
						}
					}
				}

				.item-title {
					font-size: 16px;
					font-weight: bold;
				}

				.item-desc {
					font-size: 12px;
					color: rgba(255, 255, 255, 0.6);
					margin: 10px 0;
				}

				.item-status {
					font-size: 14px;
					color: #36d1ff;

					&.warning {
						color: #ffb72b;
					}
				}
			}
		}
	}

	.alert-line {
		height: 199px;
		background: rgba(#091724, 0.8);
				// border: 1px solid #4578A8;
		border-radius: 12px;
		padding: 10px 12px;
		margin-bottom: 10px;
		position: relative;

		.line-title {
			font-size: 16px;
			margin-bottom: 6px;
		}

		.line-subtitle {
			font-size: 8px;
			color: rgba(255, 255, 255, 0.5);
		}

		.line-right-info {
			position: absolute;
			top: 12px;
			right: 13px;
			font-size: 12px;
			color: #5FE3FF;
		}

		.chart-container {
			width: 100%;
			height: 180px;
			margin-top: 16px;
		}
	}

	.event-record {
		height: 291px;
		background: rgba(#091724, 0.8);
				// border: 1px solid #4578A8;
		border-radius: 12px;
		padding: 10px 12px;
		position: relative;
		overflow-y: auto;

		.record-title {
			font-size: 16px;
			margin-bottom: 12px;
		}

		.record-right-title {
			position: absolute;
			top: 14px;
			right: 10px;
			font-size: 12px;
			color: #B3C8DC;
		}

		.record-list {
			.record-item {
				display: flex;
				align-items: center;
				height: 48px;
				padding: 6px 10px;
				background: linear-gradient(180deg, rgba(122, 191, 255, 0.1) 0%, rgba(122, 191, 255, 0) 100%);
				border-radius: 8px;
				border: 1px solid #7ABFFF;
				margin-bottom: 12px;

				&.urgent {
					background: linear-gradient(0deg, rgba(255, 74, 74, 0.5) 0%, rgba(255, 86, 74, 0) 100%);
					border: 1px solid rgba(255, 74, 74, 0.5);
				}

				&.focus {
					background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(255, 190, 74, 0) 100%);
					border: 1px solid rgba(255, 190, 74, 0.5);
				}

				.item-time {
					font-size: 10px;
					color: #B3C8DCFFF;
					margin-right: 20px;
				}

				.item-content {
					flex: 1;

					.item-name {
						font-weight: bold;
						font-size: 12px;
						color: #B3C8DCFFF;
						margin-bottom: 10px;
					}

					.item-detail {
						font-size: 10px;
						color: #B3C8DC;
					}
				}

				.item-status-btn {
					width: 50px;
					height: 20px;
					line-height: 17px;
					text-align: center;
					background: #0E161E;
					border-radius: 4px;
					border: 1px solid #7ABFFF;
					font-size: 10px;
					color: #B3C8DCFFF;

					&.urgent {
						border: 1px solid rgba(255, 74, 74, 0.5);
					}

					&.focus {
						border: 1px solid rgba(255, 190, 74, 0.5);
					}
				}
			}
		}
	}
}
</style>